/** Subtle floating section nav (left edge) with smooth scroll + scroll-spy. */
import { useEffect, useState } from 'react';

export const FloatingNav = ({ items }) => {
  const [active, setActive] = useState(items[0]?.key);

  useEffect(() => {
    const onScroll = () => {
      const pos = window.scrollY + window.innerHeight * 0.35;
      let cur = items[0]?.key;
      items.forEach((it) => {
        const el = document.querySelector(it.selector);
        if (el && el.getBoundingClientRect().top + window.scrollY <= pos) cur = it.key;
      });
      setActive(cur);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, [items]);

  const go = (it) => {
    const el = document.querySelector(it.selector);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <nav className="fnav" data-testid="floating-nav">
      {items.map((it) => (
        <button
          key={it.key}
          className={`fnav-item ${active === it.key ? 'is-active' : ''}`}
          onClick={() => go(it)}
          data-testid={`fnav-${it.key}`}
        >
          <span className="fnav-dot" />
          <span className="fnav-label">{it.label}</span>
        </button>
      ))}
    </nav>
  );
};

export default FloatingNav;
